function validate_form(block) {
  if (!block) {
    block = $('form');
  }

    var warning = $('form').find('.invalid-form-element-error');
    warning.remove();

    var valid = true;
    $('input[type!=radio][type!=checkbox], textarea, select', block).each(function (i) {
        if (typeof this.checkValidity !== 'undefined') {
          valid = valid && this.checkValidity();
          if (!this.checkValidity()) {
            $(this).parent().append("<div class='invalid-form-element-error'>That doesn't look quite right</div>");
          }
        }
    });

    // Radio & Checkbox errors
    $('ul:has(input[type=radio][required]), ul:has(input[type=checkbox][data-grouprequired])', block).each(function (i) {
      $(this).removeClass('user-error');
      var invalidGroup = incomplete_required_check_box_groups(this).length > 0;
      if (invalidGroup) {
        valid = false;
        show_group_error(this)
      }
    });

    if (!valid) {
        $('form').find(':submit').click();
      return false;
    }
    return true;
}

// Returns any checkbox lists that have all checkboxes unchecked
function incomplete_required_check_box_groups(group) {
  return $(group).not(
    function (index, el) {
      var atLeastOneChecked = $(el).find('input:checked').length > 0;
      var allInvisible = $(el).find('input:visible').length == 0
      return atLeastOneChecked || allInvisible;
    }
  );
}

// Adds the user-error class to group questions...
// Checkbox groups, Radio groups and Grids.
function show_group_error(group) {
  $(group).addClass('user-error').append("<div class='invalid-form-element-error'>That doesn't look quite right</div>");
}

function test_submit() {
  var is_valid = validate_form();
  if (is_valid) {
    document.survey.submit();
  }

  return is_valid;
}

function setupAndBindSurveyListeners() {

  $('.js-prev-block').hide();

  // Use placeholder instead of labels for personal details, BUT NOT for consents!
  $('#taker-details .form-group label:not(.consent label)').hide();

  if (!$('#survey-intro').length) {
    $('.progress-bar').show();
  }

  var currentBlockNum = 0;
  var blockCount = $('.question-block').length;

  var setProgress = function (currstep) {
    var percent = parseFloat(100 / (blockCount - 1)) * currentBlockNum;
    percent = percent.toFixed();
    $(".progress-bar")
      .css("width", percent + "%")
      .html(percent + "%")
      .attr("aria-valuenow", percent);
  };

  hide_known_member_data();

  // Apply question shuffle
  $('.question-block').each(function (i) {
    var block = this;
    if ($(block).attr('data-shuffle')) {
      $(block).children().shuffle();
    }
  });

  // Setup for multi-block survey
  if ($('.question-block').length > 1) {
    $('.question-block').hide();
    $('.question-block').first().show();
  }

  // Start Button
  $('.start-btn').click(function() {
    $('.progress-bar').show('fade');
    $("html, body").animate({ scrollTop: 0 }, "slow");
    $('#survey-intro').hide('slide', {direction: 'left'}, function () {
      $('.js-prev-block').show();
      $('#survey-form').show('slide', {direction: 'right'});
    });
  });

  $('.js-next-block,.js-skip-block').on('click', function () {
    var block = $('.question-block:visible');
    var valid = validate_form(block);
    if ($('#taker-details:visible')[0]){
      var form = $('#taker-details');
      valid &= validate_form(form);
      email_validation(form);
      postcode_validation(form);
      standard_validators();
    }
    if (valid) {
      currentBlockNum++;
      setProgress(currentBlockNum);
      $("html, body").animate({ scrollTop: 0 }, "slow");
      $('#survey-form').hide('slide', {direction: 'left'}, function () {
        $('.js-prev-block').show();
        $(block).hide();
        $(block).next().show();
        if (currentBlockNum == (blockCount - 1)) {
          // Last Block
          $('.js-next-block').hide();
          $('.js-submit').show();
        }
        $('#survey-form').show('slide', {direction: 'right'}, function() {
          if ( !$(".survey-heading").is(":visible") ) {
            $('html, body').animate({
              scrollTop: $(".survey-heading").offset().top
            }, 500);
          }
        });
      });
    }
  });

  //
  // Previous block
  //
  $('.js-prev-block').on('click', function () {
    if (currentBlockNum == 0) {
      // Back to intro, if present
      if ($('#survey-intro').length) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $('.progress-bar').hide('fade');
        $('#survey-form').hide('slide', {direction: 'right'}, function () {
          $('#survey-intro').show('slide', {direction: 'left'});
        });
      }
    } else {
      currentBlockNum--;
      setProgress(currentBlockNum);
      var block = $('.question-block:visible');
      $("html, body").animate({ scrollTop: 0 }, "slow");
      $('#survey-form').hide('slide', {direction: 'right'}, function () {
        $('.js-submit').hide();
        $('.js-next-block').show();
        if (currentBlockNum == 0) {
          // First Block
          if (!$('#survey-intro').length) {
            $('.js-prev-block').hide();
          }
          if (window.survey_info.start_with_contact_form){
            $('#taker-details').show();
          }
        }
        $(block).hide();
        $(block).prev().show();
        $('#survey-form').show('slide', {direction: 'left'}, function() {
          if ( !$(".survey-heading").is(":visible") ) {
            $('html, body').animate({
              scrollTop: $(".survey-heading").offset().top
            }, 500);
          }
        });
      });
    }
  });


  $('.recent-comments').on('click', '.js-like-comment', function (e) {
    var commentId = $(this).data('js-comment-id');
    $(this).hide();
    $.ajax({
      dataType: 'json',
      url: '/surveys/answers/' + commentId + '/like',
      method: 'post'
    }).done(function (response) {
      if (typeof response.likes !== 'undefined') {
        $('.js-comment-likes[data-js-comment-id="' + commentId + '"]').text(response.likes);
      }
    });
  });

  if ($('.question-block').length == 1) {
    $('.js-next-block,.js-prev-block').hide();
    $('.js-submit').show();
  }

  if (window.survey_info.do_submit){
    $('.js-submit-survey').trigger('click');
  }



  $(document).ready(function(){
    $('#generate-autocomplete-link-button').click(function() {
      $.ajax({
        type: "POST",
        url: "/surveys/" + window.survey_info.slug + "/generate_link",
        data: $(document.survey).serialize(), // serializes the form's elements.
        success: function(data)
        {
          alert(data);
        },
        error: function(){
          alert("ERROR. Blame Denny.");
        }
      });
      return false;
    });
  })
}


/**
 * Option to deselect radio buttons if not a required field
 */
function deselectableRadioButtons() {
  $(document).ready(function() {
    $('input[type=radio][required!=required]').on('change', function (e) {
      e.preventDefault();
      $deselect = $(this).closest('div.form-group-input').find('.deselect-radio-buttons');
      console.log($deselect);
      $deselect.removeClass('hidden');
    });

    $('.deselect-radio-buttons').on('click', function (e) {
      e.preventDefault();
      $(this).closest('div.form-group-input').find('input[type=radio]').prop('checked', false);
      $(this).addClass('hidden');
    });
  });
}


/*** EXPORTS FROM exports-loader ***/
exports["validate_form"] = (validate_form);
exports["incomplete_required_check_box_groups"] = (incomplete_required_check_box_groups);
exports["setupAndBindSurveyListeners"] = (setupAndBindSurveyListeners);
exports["deselectableRadioButtons"] = (deselectableRadioButtons);